import xhr from '../utils/xhr';
import { isNumber } from 'lodash';
import { ENTITIES_DEFAULT_SORT } from './../constants';

let api = {
    get: (oldFilters, sorting, pagination) => {
        // Fixing api incompatibility issue, will have to be consistent
        let filters = Object.assign({}, oldFilters);
        if (filters.query) filters.name = filters.query;
        if (isNumber(pagination.pageNumber)) pagination.page = pagination.pageNumber;

        const activeFilter = filters.active ? filters.active : "all";
        const categoryIdFilter = filters.categoryIdFilter && filters.categoryIdFilter !== "defaultAllCategories" ? "&categoryIdFilter=" + filters.categoryIdFilter : "";

        let nameFilter = filters.name && filters.name.length ? `&searchFilter=${encodeURIComponent(filters.name)}` : ""
        return xhr.get({
            url: `/api/entities/audit/${activeFilter}?pageNumber=${pagination.page}&pageSize=${pagination.pageSize}&sortBy=${sorting.sortBy}&direction=${sorting.direction}${nameFilter}${categoryIdFilter}`
        });
    },
    count: (oldFilters, sorting = null) => {
        // Fixing api incompatibility issue, will have to be consistent
        let filters = Object.assign({}, oldFilters);
        if (filters.query) filters.name = filters.query;
        if (!sorting) {
            sorting = ENTITIES_DEFAULT_SORT;
        }
        const activeFilter = filters.active && filters.active !== "all" ? filters.active + "/" : "";
        const categoryIdFilter = filters.categoryIdFilter && filters.categoryIdFilter !== "defaultAllCategories" ? "&categoryIdFilter=" + filters.categoryIdFilter : "";

        let nameFilter = filters.name && filters.name.length ? `&searchFilter=${encodeURIComponent(filters.name)}` : ""
        return xhr.get({
            url: `/api/entities/audit/companies/${activeFilter}count?sortBy=${sorting.sortBy}&direction=${sorting.direction}${nameFilter}${categoryIdFilter}`
        });
    }
}

export default api;


// WEBPACK FOOTER //
// ./src/scripts/api/EntitiesAudit.api.js